import { render, staticRenderFns } from "./Auto.vue?vue&type=template&id=d2cbf1aa&scoped=true"
import script from "./Auto.vue?vue&type=script&lang=ts"
export * from "./Auto.vue?vue&type=script&lang=ts"
import style0 from "./Auto.vue?vue&type=style&index=0&id=d2cbf1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cbf1aa",
  null
  
)

export default component.exports